import { LicenseManager } from 'ag-grid-enterprise';
import { useEffect, useState } from 'react';
import { Util } from 'utils';
import { registerEchartThemes } from 'utils/echart-themes';

export const useBootstrapAppSetup = () => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // * echart 테마 등록
    registerEchartThemes();
    // * AG-Grid License 초기 세팅
    LicenseManager.setLicenseKey(Util.getUniqueKey(36));
    setIsReady(true);
  }, []);

  return isReady;
};
